<section id="section-report" class="container-fluid mt-1">
  <div class="row">
    <div id="container-report" class="col-12 col-lg-12">
      <table id="main-table">
        <thead>
          <tr>
            <th id="th-head">
              <div class="row">
                <div id="head-{{predevolutionPrintModel.devolutionId}}" class="head col-12 col-lg-12">
                  <!-- Logo -->
                  <img id="logo-{{predevolutionPrintModel.devolutionId}}" [src]="logoEnterprise"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">

                  <!--Nit -->
                  <label id="t-nit-empresa-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-nit-empresa' | formatLabelPipe : elementsLabel}}</label>
                  <p id="nit-empresa-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.enterpriseNit}}</p>

                  <!--Nombre Empresa -->
                  <p id="nombre-empresa-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{predevolutionPrintModel.enterpriseName}}</p>

                  <!--Nombre Predevolución -->
                  <p id="nombre-predevolución-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{predevolutionPrintModel.titleForm}}
                  </p>

                  <!--Nombre Sucursal -->
                  <p id="nombre-sucursal-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.branchName}}</p>

                  <!--Dirección  -->
                  <label id="t-direccion-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-direccion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.branchAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono' | formatLabelPipe : elementsLabel}}
                  </label>
                  <p id="telefono-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.branchPhone}}</p>

                  <!--C.Costos  -->
                  <label id="t-centro-costos-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-centro-costos' | formatLabelPipe : elementsLabel}}</label>
                  <p id="centro-costos-{{predevolutionPrintModel.devolutionId}}" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{predevolutionPrintModel.costCenter}}</p>

                  <!-- Dirección -->
                  <label id="t-direccion-obra-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-direccion-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="direccion-obra-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.constructionSiteAddress}}</p>

                  <!--Teléfono  -->
                  <label id="t-telefono-obra-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-telefono-obra' | formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.constructionSitePhone}}</p>

                  <!--Teléfono Alterno -->
                  <label id="t-telefono-obra-alt-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-obra-alt' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-obra-alt-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.constructionSiteAlterPhone}}</p>

                  <!--Cliente  -->
                  <label id="t-cliente-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-cliente' | formatLabelPipe : elementsLabel}}</label>
                  <p id="cliente-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.clientName}}</p>

                  <!--Teléfono del cliente -->
                  <label id="t-telefono-cliente-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-cliente' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-cliente-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.clientPhone}}</p>

                  <!--Teléfono Alterno del cliente -->
                  <label id="t-telefono-cliente-alt-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">{{'t-telefono-cliente-alt' |
                    formatLabelPipe : elementsLabel}}</label>
                  <p id="telefono-cliente-alt-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{predevolutionPrintModel.clientAlterPhone}}</p>

                  <!-- Fecha Predevolución -->
                  <label id="t-fecha-predevolucion-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-fecha-predevolucion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-predevolucion-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.datePredevolution | date: 'dd/MM/yyyy'}}</p>

                  <!-- Hora Predevolución -->
                  <label id="t-hora-predevolucion-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-hora-predevolucion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="hora-predevolucion-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.datePredevolution | date: 'mediumTime'}}</p>

                  <!-- Fecha Factura -->
                  <label id="t-fecha-factura-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-factura' | formatLabelPipe : elementsLabel}}</label>
                  <p id="fecha-factura-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.dateInvoice | date: 'dd/MM/yyyy'}}</p>

                  <!--Fecha Recibo  -->
                  <label id="t-fecha-recibo-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-fecha-recibo' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-fecha-recibo-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Hora Llegada  -->
                  <label id="t-hora-llegada-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-hora-llegada' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-hora-llegada-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!--Hora Salida  -->
                  <label id="t-hora-salida-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-hora-salida' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-hora-salida-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!-- Linea 1  -->
                  <p id="linea-uno-{{predevolutionPrintModel.devolutionId}}" class="write-line" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!-- Anunciante -->
                  <label id="t-anunciante-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-anunciante' | formatLabelPipe : elementsLabel}}</label>
                  <p id="anunciante-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.advertiser}}</p>

                  <!-- Devolución  -->
                  <label id="t-devolucion-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-devolucion' | formatLabelPipe : elementsLabel}}</label>
                  <p id="linea-devolucion-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                    (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!-- Linea 2  -->
                  <p id="linea-dos-{{predevolutionPrintModel.devolutionId}}" class="write-line" (click)="onClick()"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>

                  <!-- Transportador-->
                  <p id="transportador-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()"> {{predevolutionPrintModel.transporter}}</p>
                  <label id="t-transportador-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-transportador' | formatLabelPipe : elementsLabel}}</label>

                  <!-- Vehículo (Placa)-->
                  <label id="t-vehiculo-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{'t-vehiculo' | formatLabelPipe : elementsLabel}}</label>
                  <p id="vehiculo-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.plateVehicle}}</p>

                  <!-- Valor Transporte -->
                  <label id="t-valor-transporte-{{predevolutionPrintModel.devolutionId}}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{'t-valor-transporte' | formatLabelPipe : elementsLabel}}</label>
                  <p id="valor-transporte-{{predevolutionPrintModel.devolutionId}}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.transportValue | currency}}</p>

                  <!--Ciudad destino  -->
                  <label id="t-ciudad-destino-{{ predevolutionPrintModel.devolutionId }}"
                    (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                    {{"t-ciudad-destino" | formatLabelPipe : elementsLabel}}</label>
                  <p id="ciudad-destino-{{ predevolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.destinityCity}}</p>

                  <!--Comodin 1  -->
                  <label id="t-comodin-1-{{ predevolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{"t-comodin-1" | formatLabelPipe : elementsLabel}}</label>
                  <p id="comodin-1-{{ predevolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.wildcard}}</p>

                  <!-- Comodin 2 -->
                  <label id="t-comodin-2-{{ predevolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{"t-comodin-2" | formatLabelPipe : elementsLabel}}</label>
                  <p id="comodin-2-{{ predevolutionPrintModel.devolutionId }}" (mousedown)="onMouseDown($event)"
                    (dragstart)="onDragStart()">{{predevolutionPrintModel.wildcard2}}</p>

                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div class="table-container">
                <app-custom-table-print id="detalle-predevolucion-{{predevolutionPrintModel.devolutionId}}"
                  [columns]="columns" [data]="predevolutionPrintModel.devolutionDetails" [idMap]="idMap"
                  [documentId]="predevolutionPrintModel.devolutionId" [footerVisible]="true" [editFormat]="editFormat"
                  (clickTableEvent)="clickTable($event)"
                  (newIndexColumns)="onColumnReorder($event)"></app-custom-table-print>
              </div>
              <!-- Observaciones -->
              <div id="foot-{{predevolutionPrintModel.devolutionId}}" class="foot mt-1 container-observations">
                <!-- Equipo Disponible -->
                <label id="t-equipo-disponible-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-equipo-disponible' | formatLabelPipe : elementsLabel}}</label>

                <!-- Cuando recoge Equipo -->
                <label id="t-cuando-recoge-equipo-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-cuando-recoge-equipo' | formatLabelPipe : elementsLabel}}</label>

                <!-- Fecha Nueva recolección -->
                <p id="linea-fecha-nueva-recoleccion-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-fecha-nueva-recoleccion-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-linea-fecha-nueva-recoleccion' | formatLabelPipe : elementsLabel}}</label>

                <!-- Firma Cliente-->
                <p id="linea-firma-cliente-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-firma-cliente-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-linea-firma-cliente' | formatLabelPipe : elementsLabel}}</label>

                <!-- Observaciones -->
                <label id="t-observacion-predevolucion-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="predevolutionPrintModel.printObservation">
                  {{'t-observacion-predevolucion' | formatLabelPipe : elementsLabel}}</label>

                <p id="observacion-predevolucion-{{predevolutionPrintModel.devolutionId}}" class="lh-sm"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"
                  *ngIf="predevolutionPrintModel.printObservation">
                  {{predevolutionPrintModel.printObservation}}
                </p>

                <!-- Observaciones Sucursal -->
                <p id="observacion-sucursal-{{predevolutionPrintModel.devolutionId}}" class="lh-sm"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{predevolutionPrintModel.devolutionObservation}}</p>

                <!-- Firma Transportador-->
                <p id="linea-firma-transportador-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-firma-transportador-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-linea-firma-transportador' | formatLabelPipe : elementsLabel}}</label>

                <!-- Firma Entrega-->
                <p id="linea-firma-entrega-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-firma-linea-entrega-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-firma-linea-entrega' | formatLabelPipe : elementsLabel}}</label>

                <!-- Firma Recibe-->
                <p id="linea-firma-recibe-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-firma-recibe-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-linea-firma-recibe' | formatLabelPipe : elementsLabel}}</label>

                <!-- Fecha - Hora Recepción:-->
                <p id="linea-datos-recepcion-{{predevolutionPrintModel.devolutionId}}" class="write-line"
                  (click)="onClick()" (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()"></p>
                <label id="t-linea-datos-recepcion-{{predevolutionPrintModel.devolutionId}}"
                  (mousedown)="onMouseDown($event)" (dragstart)="onDragStart()">
                  {{'t-linea-datos-recepcion' | formatLabelPipe : elementsLabel}}</label>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="1" id="td-foot">
              <div class="information-print d-flex">
                <p id="version-cervino" class="fw-bold pe-4 ">{{version}}</p>
                <label id="t-fecha-impresion" class="fw-bold pe-2">Fecha: </label>
                <p id="fecha-impresion" class="pe-4">{{dateNow | date: 'dd/MM/yyyy'}}</p>
                <label id="t-hora-impresion" class="fw-bold pe-2">Hora: </label>
                <p id="hora-impresion" class="pe-4"> {{dateNow | date: 'hh:mm:ss a'}}</p>
                <label id="t-usuario-impresion" class="fw-bold pe-2">Usuario: </label>
                <p id="usuario-impresion" class="pe-4"> {{predevolutionPrintModel.userAuthenticated}}</p>
              </div>
              <div class="d-flex flex-column justify-content-center">
                <div class="d-flex justify-content-center">
                  <p class="mt-2 information-print">Documento generado con el Software Cervino Web de Altos Software
                    SAS. Nit.811.022.121-1. www.altos-soft.com</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</section>